import { render } from "./kaoyan.vue?vue&type=template&id=a364c848&scoped=true"
import script from "./kaoyan.vue?vue&type=script&lang=js"
export * from "./kaoyan.vue?vue&type=script&lang=js"

import "./kaoyan.vue?vue&type=style&index=0&id=a364c848&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a364c848"]])

export default __exports__